export default "__VITE_ASSET__3R4nsd3K__"